'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Components


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _dependencies = require('../../../dependencies');

require('./Checkbox.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkbox = function Checkbox(props) {
    return _react2.default.createElement(
        'div',
        _extends({ contentEditable: false, className: (0, _classnames2.default)('Checkbox', { checked: props.checked }) }, props),
        _react2.default.createElement(_dependencies.Icon, { name: 'tick' })
    );
};

Checkbox.propTypes = {
    checked: _propTypes2.default.bool
};

exports.default = Checkbox;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/checklist/components/Checkbox.js
// module id = 1720
// module chunks = 0